import React, { ReactNode, Suspense, lazy, useCallback, useMemo } from 'react';
import S from './container-lista.styles';
import { ContainerListaProps } from './container-lista.types';

const Erro = lazy(() => import('./fragments/erro/erro.fragment'));
const Header = lazy(() => import('./fragments/header/header.fragment'));
const Lista = lazy(() => import('./fragments/lista/lista.fragment'));
const MensagemSemConteudo = lazy(
  () =>
    import('./fragments/mensagem-sem-conteudo/mensagem-sem-conteudo.fragment'),
);

/**
 * @param children
 * É esperado uma lista de Cards que serão dispostos em formato de grid.
 */
export const ContainerLista: React.FC<ContainerListaProps> = ({
  children,
  estadoRequisicao,
  onRetentativa,
  descricaoLista,
  titulo,
}) => {
  const { erro, pendente, semConteudo } = estadoRequisicao;

  const Conteudo = useCallback(
    ({
      content,
      descricaoLista,
    }: {
      content: ReactNode;
      descricaoLista: ReactNode;
    }) => {
      if (pendente) {
        return <MensagemSemConteudo pendente />;
      }

      if (erro) {
        return <Erro onRetentativa={onRetentativa} />;
      }

      if (semConteudo) {
        return <MensagemSemConteudo />;
      }

      return <Lista descricao={descricaoLista}>{content}</Lista>;
    },
    [erro, onRetentativa, pendente, semConteudo],
  );

  const Screen = useMemo(() => ({ Header, Conteudo }), [Conteudo]);

  return (
    <S.Container
      aria-labelledby="titulo-sessao"
      aria-describedby="subtitulo-sessao"
      data-testid="section-cursos-complementares"
      data-section="section_cursos-complementares"
    >
      <Screen.Header>{titulo}</Screen.Header>
      <Suspense>
        <Screen.Conteudo descricaoLista={descricaoLista} content={children} />
      </Suspense>
    </S.Container>
  );
};
